import { combineReducers } from 'redux';
import settings from './settings';
import teams from './teams';
import users from './users';
import location from './location';
import roxanne from './roxanne';
import conversation from './conversation';
import visitor from './visitor';
import message from './message';
import ui from './ui';
import video from './video';

const rootReducer = combineReducers({
    settings,
    teams,
    users,
    location,
    roxanne,
    conversation,
    visitor,
    message,
    ui,
    video,
});

export default rootReducer;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/reducers/index.ts